import React from 'react';
import {
	Compass,
	Map,
	Shield,
	ShieldCheck,
	Award,
	Trophy,
} from 'lucide-react';

const ICONS = { Compass, Map, Shield, ShieldCheck, Award, Trophy };

const PALETTE = {
	explorer: { from: '#475569', to: '#64748B', text: '#FFFFFF' },
	planner: { from: '#0EA5E9', to: '#0284C7', text: '#FFFFFF' },
	protector: { from: '#1E3A8A', to: '#1E40AF', text: '#FFFFFF' },
	guardian: { from: '#059669', to: '#10B981', text: '#FFFFFF' },
	resilience_leader: { from: '#7C3AED', to: '#A855F7', text: '#FFFFFF' },
	family_champion: { from: '#D97706', to: '#F59E0B', text: '#FFFFFF' },
};

export default function LevelBadge({ level, size = 'md', showTitle = true, className = '' }) {
	if (!level) return null;
	const Icon = ICONS[level.icon] || Shield;
	const palette = PALETTE[level.key] || PALETTE.protector;
	const box = size === 'sm' ? 'w-8 h-8' : size === 'lg' ? 'w-14 h-14' : 'w-10 h-10';
	const text = size === 'lg' ? 'text-base' : 'text-sm';
	return (
		<div className={`inline-flex items-center gap-2.5 ${className}`}>
			<div
				className={`${box} rounded-2xl grid place-items-center shadow-sm`}
				style={{ background: `linear-gradient(135deg, ${palette.from}, ${palette.to})`, color: palette.text }}
			>
				<Icon className="w-1/2 h-1/2" strokeWidth={2.4} />
			</div>
			{showTitle && (
				<div>
					<div className="text-[10px] uppercase tracking-[0.2em] font-bold text-slate-400">Level</div>
					<div className={`font-heading font-semibold text-slate-900 ${text}`}>{level.title}</div>
				</div>
			)}
		</div>
	);
}
